import { Link } from 'react-router-dom';
import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  return (
    <main dir="rtl">
      <Navbar />
      <section className="min-h-screen flex items-center justify-center px-6 bg-[#F5F1E8] relative overflow-hidden">
        {/* Big 404 bg */}
        <div className="absolute inset-0 flex items-center justify-center select-none pointer-events-none">
          <span className="text-[22rem] font-black text-[#C9A961]/5 leading-none">404</span>
        </div>

        <div className="relative z-10 text-center max-w-lg">
          {/* Icon */}
          <div className="w-24 h-24 flex items-center justify-center bg-white rounded-full mx-auto mb-8 border border-[#C9A961]/20">
            <i className="ri-map-pin-2-line text-5xl text-[#C9A961]" />
          </div>

          <h1 className="text-6xl font-black text-[#C9A961] mb-3">404</h1>
          <h2 className="text-2xl font-black text-gray-900 mb-4">الصفحة غير موجودة</h2>
          <p className="text-gray-500 text-base leading-relaxed mb-10">
            عذراً، الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.<br />
            لكن لا تقلق — موقعنا مليء بالمنتجات الرائعة!
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="flex items-center gap-2 bg-[#C9A961] text-white px-8 py-4 rounded-full font-bold hover:bg-[#A07C30] transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-4-line" />
              </div>
              العودة للرئيسية
            </Link>
            <Link
              to="/products"
              className="flex items-center gap-2 border-2 border-[#C9A961] text-[#C9A961] px-8 py-4 rounded-full font-bold hover:bg-[#C9A961] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-store-2-line" />
              </div>
              تصفح المنتجات
            </Link>
          </div>

          {/* Quick links */}
          <div className="flex flex-wrap items-center justify-center gap-5 mt-10 pt-8 border-t border-gray-200">
            {[
              { label: 'المنتجات', path: '/products' },
              { label: 'أفلام ومسلسلات', path: '/movies' },
              { label: 'تواصل معنا', path: '/contact' },
              { label: 'الأسئلة الشائعة', path: '/faq' },
            ].map(link => (
              <Link
                key={link.path}
                to={link.path}
                className="text-gray-400 text-sm hover:text-[#C9A961] transition-colors cursor-pointer"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}
